import React, { Suspense } from "react";

const HomePage = React.lazy(() => import("../view/create-2.jsx"));

const Home = () => {
  return (
    <Suspense fallback={null}>
      <HomePage />
    </Suspense>
  );
};

export default Home;
